export const locale = {
    lang: 'pl',
    data: {
        'Notifications': 'Powiadomienia',
        'Add notification': 'Dodaj powiadomienie',
        'Edit': 'Edycja',
        'Template': 'Szablon',
        'Reason': 'Powód',
        'incoming-reservation': 'Zbliżająca się rezerwacja',
        'Created at': 'Data dodania',
        'Delete': 'Usuń',
        'Actions': 'Akcje',
        'Notification data': 'Konfiguracja powiadomienia',
        'Hours before send': 'Ilość godzin przed',
        'Enabled': 'Włączone',
        'Save': 'Zapisz',
    }
};
